import type { ShopifyAsset } from '~/modules/shopify/types';
import type { IThemePage } from '~/stores/themePage';

export const getAssetKey = (asset: ShopifyAsset, _themePages?: IThemePage[]): string => {
  return asset.key ?? '';

  // TODO: Remove this after merge theme page default
  // if (asset.providerSource !== ProviderSource.GEMPAGESV7 || !themePages?.length) return key;
  // // Check template default V7
  // const templateId = parseTemplateIdBy(key, ProviderSource.GEMPAGESV7);
  // const themePageIdx = themePages.findIndex((page) => page.default && page.id === templateId);
  // if (themePageIdx === -1) return key;

  // const templateInfo = parseTemplateInfoBy({ templateSuffix: key });
  // return `templates/${templateInfo?.type}.${templateInfo?.fileExtension}`;
};
